<template>
  <v-dialog v-model="openDialog" scrollable :width="width" :height="height" :fullscreen="fullscreen">
    <div class="text-center white" :class="!isMobile ? '' : 'overflow-y-auto'">
      <DefaultIframe v-if="!isMobile || isWebUrl" :url="url" :border="border" :height="height" />
      <vue-pdf-embed v-else :source="url"></vue-pdf-embed>
      <DefaultButton :colorType="'cancel'" small class="text__size-14" @doFunction="openDialog = false"> <span>關閉</span></DefaultButton>
    </div>
  </v-dialog>
</template>

<script>
import store from '@/store';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    url: {
      type: String,
    },
    width: {
      type: String,
    },
    border: {
      type: [String],
    },
    height: {
      type: String,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDialog: false,
      isMobile: false,
      isWebUrl: false,
    };
  },
  watch: {
    value(val) {
      this.isMobile = store.state.isMobile;
      this.isWebUrl = this.url.includes('singlePage=true');
      this.openDialog = val;
      // // 判斷是否為手機瀏覽
      // if (!store.state.isMobile) {
      //   // PC 開啟彈出視窗
      //   this.openDialog = val;
      // } else {
      //   // 手機 開啟檔案
      //   if (val === true) {
      //     window.open(this.url);
      //   }
      //   this.$emit('input', false);
      // }
    },
    openDialog(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
